import { useState, useCallback } from 'react';

export default function useConfirm() {
    const [state, setState] = useState({ open: false, title: '', message: '', confirmLabel: '', cancelLabel: '', danger: false, resolve: null });

    const confirm = useCallback(({ title, message, confirmLabel, cancelLabel, danger } = {}) => {
        return new Promise((resolve) => {
            setState({ open: true, title: title || 'Are you sure?', message: message || '', confirmLabel, cancelLabel, danger: !!danger, resolve });
        });
    }, []);

    const onConfirm = useCallback(() => {
        state.resolve?.(true);
        setState(s => ({ ...s, open: false }));
    }, [state.resolve]);

    const onCancel = useCallback(() => {
        state.resolve?.(false);
        setState(s => ({ ...s, open: false }));
    }, [state.resolve]);

    return { confirm, confirmProps: { ...state, onConfirm, onCancel } };
}
